/*
*
*  /js/helpMap_HC.js - contains the Healthcare help map ids used in the RoboHelp help system
*
*  The Map Ids identify the WorkFlows
* 	 e.g.
* 
*  		CA is the Id for the Case Assembly workflow main tab (grid tab)
*  		
* 		The Search Id is 'Search' for the search tab, regardless of the workflow
*
*  Workflow codes are:
* 
* 		AC  - All Cases
* 		CA  - Case Assembly
* 		CR  - Case Review
* 		IOC - IntraOperative
* 		IC  - Incoming Consult
* 		OC  - Outgoing Consult
* 
*  06/07/12	- Ellis - initial version. Created from BSSCDefault.h which is generated by the WebHelp project
*/
var helpMap_HC = new function()
{
	// object maps Healthcare map id keys to the numeric values that are used by the WebHelp system
	var helpMap =
	{
		"Healthcare"  :	1,
		"CR" 		  :	2,
		"CA" 		  :	3,
		"IOC" 		  :	4,
		"IC" 		  :	5,
		"OC" 		  :	6,
		"Search"	  :	8,
		"Admin"		  : 11,
		"AC"		  :	19
	};

	/**
	* mapIdKey
	*
	* returns numeric map id for a map id key.
	* if key does not exist, return numeric map id for HealthCare.
	* 
	* @param key - map id key, e.g. CA_Case_Data
	*/
	this.mapIdKey = function(key)
	{
		if (undefined !== helpMap[key])	
			return helpMap[key];
		return helpMap.Healthcare;
	}
};